export const SPACE_OCCUPANCY = 'USER_FEEDBACK'
export const FILTER_NAME = 'userFeedback'
export const PAGENAME = 'userFeedback'
export const ns = 'UserFeedback'

export const USER_FEEDBACK_STORE_KEY = 'userFeedback'
export const DEFAULT_PAGE_SIZE = 10
export const SELECTED_ROWS_COUNT = `${ns}.SELECTED_ROWS_COUNT`

export const BASE_TIME_FORMAT = 'YYYY/MM/DD'

export const NOTCOVERED = 'notCovered'
export const UNLOCKED = 'unlocked'
export const NOTSPACE = 'notSpace'
export const NOTINPUTTABLE = 'notInputtable'

export const STORE_ROLE = 'ublique-store-manager'

export const statusMap = {
  SBLOCCATO_TOTALE: 'SBLOCCATO_TOTALE',
  SBLOCCO_PARZIALE: 'SBLOCCO_PARZIALE',
  SBLOCCATO: 'SBLOCCATO',
  BLOCCATO: 'BLOCCATO'
}
